/**
 * Error de negocio/validación que la UI puede mostrar tal cual.
 * - messages: lista de mensajes legibles (en español).
 * - fieldErrors: { campo: ['mensaje', ...] } cuando el backend valida por campo.
 * - status: código HTTP si se conoce (opcional).
 * - controlled: true si el mensaje viene de una respuesta controlada del backend (apta para mostrar tal cual).
 */
export class DomainError extends Error {
  constructor(messages, fieldErrors = null, status = null, controlled = false) {
    const list = (Array.isArray(messages) ? messages : [messages]).filter(Boolean);
    super(list.length ? list.join('\n') : 'Ocurrió un error');
    this.name = 'DomainError';
    this.messages = list;
    this.fieldErrors = fieldErrors;
    this.status = status;
    this.controlled = controlled;
  }
}

export default DomainError;
